<section class="container no-padding no-margin">
  <div class="header-wrapper">
    <p>
      <span class="headerText">Feeds</span>
    </p>
  </div>
  <div class="implementation-hub-link">
    <a
      mat-raised-button
      color="accent"
      class="implementation-hub-button"
      href="https://insights.ecoonline.com/professional-services/ehs-implementation-hub/documents-and-templates"
      target="_blank"
      rel="noopener noreferrer"
      data-qa-id="feed-summary-implementation-hub-link"
      >
      Documents and Templates - EHS Implementation Hub
    </a>
  </div>
  <div class="content-wrapper">
    <div>
      <table data-qa-id="feeds-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Description</th>
            <th class="column-updated">Last Updated (UTC)</th>
            <th class="column-sso-feed">User Permission Feed</th>
            <th class="column-enabled">Enabled</th>
            <th class="column-delete">Delete</th>
            <th class="column-delete">History</th>
          </tr>
        </thead>
        <tbody>
          @for (feedConfiguration of feedConfigurations; track feedConfiguration) {
            <tr>
              <td>
                <a routerLink="{{ feedConfiguration.Id }}" id="feed-config-{{ feedConfiguration.Id }}" [attr.data-qa-id]="'feeds-link-config-' + feedConfiguration.Id">
                  {{ feedConfiguration.Name }}
                </a>
              </td>
              <td>{{ feedConfiguration.Description }}</td>
              <td class="column-updated">
                {{
                getFeedUpdatedOn(feedConfiguration)
                | date : "dd/MM/yyyy HH:mm:ss" : "UTC"
                }}
              </td>
              <td class="column-sso-feed">
                @if (feedConfiguration.SSOFeed) {
                  <span>&#10004;</span>
                }
              </td>
              <td class="column-enabled">
                <mat-slide-toggle [checked]="feedConfiguration.Enabled" (change)="
                    setFeedConfigurationEnabled(
                      feedConfiguration.Id,
                      !feedConfiguration.Enabled
                    )
                  " id="feed-enabled-{{ feedConfiguration.Id }}" [attr.data-qa-id]="'feeds-toggle-enabled-' + feedConfiguration.Id"></mat-slide-toggle>
              </td>
              <td class="column-delete">
                @if (itemIdSelectedForDeletion !== feedConfiguration.Id) {
                  <button mat-button (click)="selectItemForDeletion(feedConfiguration.Id)"
                  id="feed-configuration-delete-configuration-{{
                    feedConfiguration.Id
                  }}" [attr.data-qa-id]="'feeds-btn-delete-' + feedConfiguration.Id">
                    <mat-icon>delete</mat-icon>
                  </button>
                }
                @if (itemIdSelectedForDeletion === feedConfiguration.Id) {
                  <span
                    title="Are you sure you want to delete this feed?">
                    Sure?&nbsp;
                    <button mat-button color="warn" (click)="deleteButtonClicked(feedConfiguration.Id)" title="Delete it"
                      id="feed-configuration-delete-configuration-confirm-{{feedConfiguration.Id}}"
                      [attr.data-qa-id]="'feeds-btn-delete-confirm-' + feedConfiguration.Id">
                      <mat-icon>delete</mat-icon>
                    </button>
                    <button mat-icon-button (click)="selectItemForDeletion(null)" title="Cancel"
                      id="feed-configuration-delete-configuration-cancel-{{feedConfiguration.Id}}"
                      [attr.data-qa-id]="'feeds-btn-delete-cancel-' + feedConfiguration.Id">
                      <mat-icon>close</mat-icon>
                    </button>
                  </span>
                }
              </td>
              <td class="column-history">
                <mat-icon
                  class="history-toggle"
                  [attr.data-qa-id]="'feeds-btn-toggle-history-' + feedConfiguration.Id"
                  [attr.aria-label]="'Toggle feed history for ' + feedConfiguration.Name"
                  role="button"
                  tabindex="0"
                  (click)="toggleHistory(feedConfiguration.Id)"
                  (keydown)="onHistoryKeyDown($event, feedConfiguration.Id)"
                >history</mat-icon>
              </td>
            </tr>
            <tr [ngClass]="{
                'show-history': shouldHistoryBeDisplayed(feedConfiguration.Id)
              }" class="history-row">
              <td colspan="7">
                @if (!existsHistory(feedConfiguration.Id)) {
                  <div class="history-margin"
                    [attr.data-qa-id]="'feeds-text-no-history-' + feedConfiguration.Id">
                    There is no history available for this feed configuration.
                  </div>
                } @else {
                  <div>
                    <div>Search for the Trace Id as '&#64;otel.trace_id' in Datadog for detailed logs.</div>
                  </div>
                  <table class="history-margin">
                    <thead>
                      <th>Date</th>
                      <th>Time Run</th>
                      <th>Status &amp; File Name</th>
                      <th>Trace Id</th>
                      <th>File</th>
                      <th></th>
                      <th></th>
                    </thead>
                    <tbody>
                      @for (history of feedHistories[feedConfiguration.Id]; track history) {
                        <tr>
                          <td>{{ history.CreatedOn | date : "dd/MM/yyyy HH:mm:ss" : "UTC" }}</td>
                          <td>{{ history.TimeRun }}</td>
                          <td>
                            @if (history.IsFileDownloadAvailable && hasFeedFileDownloadPermission()) {
                              <button
                                type="button"
                                class="link-button"
                                (click)="downloadFile(history)"
                                [attr.data-qa-id]="'feeds-link-download-file-' + history.Id"
                                title="Download the processed file"
                                >
                                {{ history.Status }}
                              </button>
                            } @else {
                              {{ history.Status }}
                            }
                          </td>
                          <td>{{ history.TraceId }}</td>
                          <td>
                            @if (hasErrorReport(history)) {
                              <a
                                mat-button
                                color="primary"
                                [href]="history.ReportDownloadUrl"
                                target="_blank"
                                rel="noopener noreferrer"
                                [attr.data-qa-id]="'feeds-btn-download-errors-' + history.Id"
                                title="Download the errors file"
                                >
                                <mat-icon>download</mat-icon> Errors
                              </a>
                            }
                          </td>
                          <td>
                            @if (history.JobId || history.jobId) {
                              <button mat-button color="accent" (click)="toggleJobLiveView(history.JobId || history.jobId)">View</button>
                            }
                          </td>
                          <td>
                            @if (history.IsRetryable) {
                              <button
                                mat-icon-button
                                color="accent"
                                [disabled]="isRetrying(history.Id)"
                                (click)="confirmRetry(history, feedConfiguration.Id)"
                                [attr.data-qa-id]="'feeds-btn-retry-' + history.Id"
                                title="Retry this failed import"
                                >
                                <mat-icon>refresh</mat-icon>
                              </button>
                            }
                          </td>
                        </tr>
                        @if (activeLiveViewJobId === (history.JobId || history.jobId) && (history.JobId || history.jobId)) {
                          <tr>
                            <td colspan="7">
                              <job-liveview [jobId]="history.JobId || history.jobId"></job-liveview>
                            </td>
                          </tr>
                        }
                      }
                    </tbody>
                  </table>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="nav-buttons">
      <button mat-raised-button routerLink="new" color="accent" id="new-feed" data-qa-id="feeds-btn-new">
        New
      </button>
    </div>
  </div>
</section>
